import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { formatCurrency } from '../../../../helpers/format';
import { useTranslation } from 'react-i18next';



const TournamentBadBetDialog = ({ tournament, onClose }) => {
  const { t } = useTranslation();
  const BTN_NAMES = {
    confirm: t('ok'),
  };
  if (!tournament) return false;
  const currency = tournament.buyIn.currency;

  return (
    <>
      <div className="tournaments__popup tournaments__dialog-bet-information">
        <div className="tournaments__popup__overlay tournaments__dialog-bet-information__overlay" onClick={onClose} />
        <PopUpDialogTemplate
          title={t('betSizeError')}
          onConfirm={onClose}
          onClose={onClose}
          btnNames={BTN_NAMES}
          errorHeader
          className="popup__dialog--wide"
          bodyClassName="tournaments__dialog-bet-information__body"
        >
          <div className="tournaments__dialog-bet-information__error-message">
            <span>{t('badBetSize')}</span>
          </div>
          <div className="tournaments__dialog-bet-information__bet-information">
            <div className="tournaments__dialog-bet-information__bet-information-item">
              <span>{t('betAmount')}:</span>
              <b>{tournament.minBet}</b>
            </div>
          </div>
          <div className="tournaments__dialog-bet-information__description-wrapper">
            <p className="tournaments__dialog-bet-information__description-title">{t('changeBetLevel')}</p>
            <p className="tournaments__dialog-bet-information__description-text">{t('betAmountChange')}</p>
          </div>
        </PopUpDialogTemplate>
      </div>

    </>
  )
}

export default TournamentBadBetDialog;